import React from 'react';
import useSWR from '@zeit/swr';
import cn from 'classnames/bind';

import ActionButton from '../ActionButton/ActionButton';

import styles from './LogsHeader.module.css';
import axios from '../../../../utils/axios';
import { isAdminOrModer } from '../../../../utils/user-role';

const cx = cn.bind(styles);

function LogsHeader(props) {
  const { data: user } = useSWR('/users/me/', axios);
  // replace props.logs to swr data
  // const { data: logs } = useSWR('/logs', axios);
  const logs = props.logs;

  function handleReloadClick() {
    document.location.reload(false);
  }

  return (
    <div className={cn(styles.header, props.className)}>
      <h1 className={styles.title}>Список журналов</h1>

      <div className={styles.buttons}>
        {isAdminOrModer(user?.data?.role) && (
          <ActionButton
            className={cx({ button: true, 'button-add': true })}
            role="link"
            icon="plus"
            fill="var(--white)"
            to="/log/create"
          >
            Добавить журнал
          </ActionButton>
        )}

        {/* replace */}
        {/* {!!logs?.data?.results.length && ( */}
        {!!logs?.results && (
          <ActionButton
            className={cx({ button: true, 'button-reload': true })}
            role="button"
            icon="reload"
            onClick={handleReloadClick}
          >
            Обновить
          </ActionButton>
        )}
      </div>
    </div>
  );
}

export default LogsHeader;
